import React, { useEffect, useState } from 'react';
import { Components } from './styled';
import ProjectModal from '../../ProjectModal';
import { SMALL_PROJECT_MODAL_WIDTH } from '../../../utils/styled/dimensions';
import { buildDefaultPostTitle } from '../../../api/types/lesson';
import { DAILY_SESSION_NETWORK_ID, DAILY_SESSION_NETWORK_NAME } from '../../../defines';
import ProjectTextField from '../../inputs/ProjectTextField';

const SelectNetworkModal = ({
  isModalOpen,
  onModalClose,
  onContinue,
  lessonTitle,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  onContinue: (
    postToNetworkId: string | undefined,
    postTitle: string | undefined,
    postContent: string | undefined,
  ) => void;
  lessonTitle?: string;
}) => {
  const [postTitle, setPostTitle] = useState('');
  const [postContent, setPostContent] = useState('');

  const defaultPostTitle = buildDefaultPostTitle(lessonTitle);

  // The modal stays mounted between publishes, so clear the previous lesson's content.
  useEffect(() => {
    if (isModalOpen) {
      setPostTitle('');
      setPostContent('');
    }
  }, [isModalOpen]);

  const _onContinue = () => {
    const _postTitle = postTitle?.trim()?.length ? postTitle.trim() : defaultPostTitle;
    onContinue(
      DAILY_SESSION_NETWORK_ID || undefined,
      _postTitle?.length ? _postTitle : undefined,
      postContent?.length ? postContent : undefined,
    );
  };

  return (
    <ProjectModal
      bodyChildren={
        <Components.ModalBodyContainer>
          <Components.Description>
            {DAILY_SESSION_NETWORK_ID
              ? 'This session will be posted to the network configured for this environment.'
              : 'No network is configured for this environment, so the session will publish without a post.'}
          </Components.Description>
          <Components.FieldLabel>Network</Components.FieldLabel>
          <Components.ReadOnlyField>
            {DAILY_SESSION_NETWORK_NAME || DAILY_SESSION_NETWORK_ID ? (
              <Components.ReadOnlyValue>
                {DAILY_SESSION_NETWORK_NAME || DAILY_SESSION_NETWORK_ID}
              </Components.ReadOnlyValue>
            ) : (
              <Components.NotSetValue>Not configured</Components.NotSetValue>
            )}
          </Components.ReadOnlyField>
          <Components.FieldLabel>Post title</Components.FieldLabel>
          <ProjectTextField
            value={postTitle}
            onChangeText={(e) => setPostTitle(e.target.value)}
            placeholder={defaultPostTitle || 'Daily Alux: {lesson title}'}
            disabled={!DAILY_SESSION_NETWORK_ID}
          />
          <Components.FieldLabel>Post content</Components.FieldLabel>
          <Components.TextArea
            value={postContent}
            onChange={(e) => setPostContent(e.target.value)}
            placeholder={'Add optional post content'}
            disabled={!DAILY_SESSION_NETWORK_ID}
          />
        </Components.ModalBodyContainer>
      }
      buttonChildren={
        <Components.ModalButtonsContainer>
          <Components.Button onClick={_onContinue}>Publish</Components.Button>
        </Components.ModalButtonsContainer>
      }
      isModalOpen={isModalOpen}
      onModalClose={onModalClose}
      modalTitle={'Publish daily session'}
      modalWidth={SMALL_PROJECT_MODAL_WIDTH}
      disableCloseOnClickAway
    />
  );
};

export default SelectNetworkModal;
